import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'contacts-sort-order',
  templateUrl: './contacts-sort-order.component.html',
  styleUrls: ['./contacts-sort-order.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactsSortOrderComponent extends BaseResizableComponent {
  @Input() loading: boolean = false;
}
